import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { ActivatedRoute, Params } from '@angular/router';
import moment from 'moment';
import { faCircleArrowLeft, faPaperPlane, faPenToSquare, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FinancialService } from '../_services/financial.service';
import { Payment } from '../_models/payment';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-payment',
  standalone: false,

  templateUrl: './payment.component.html',
  styleUrl: './payment.component.css'
})
export class PaymentComponent implements OnInit {

  action: any;
  payment!: Payment;
  property: any;

  viewPaymentForm!: FormGroup;

  submitPaymentData = false;
  sortOrder: "desc" | "asc" = "desc";

  faCircleArrowLeft = faCircleArrowLeft;
  faPaperPlane = faPaperPlane;
  faPenToSquare = faPenToSquare;
  faArrowLeft = faArrowLeft;

  constructor(
    private _location: Location,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private financialService: FinancialService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => this.action = params['action']);

    let propertystr = localStorage.getItem('property');
    this.property = JSON.parse(propertystr ? propertystr : '{}');

    this.viewPaymentForm = this.formBuilder.group({
      amount: [{ value: '', disabled: true }],
      effective_date: [{ value: '', disabled: true }],
      description: [{ value: '', disabled: true }],
      period_date: [{ value: '', disabled: true }],
      paid_by: [{ value: '', disabled: true }],
      premiseId: [{ value: '', disabled: true }],
      payment_method: [{ value: '', disabled: true }],
      unitNumber: [{ value: '', disabled: true }],
      propertyName: [{ value: '', disabled: true }],
    });

    if (this.action == 'view') {
      this.financialService.selectedPayment$.subscribe((value) => {
        if (value === undefined || !value.id) {
          let paymentstr = localStorage.getItem('stpayment');
          this.payment = JSON.parse(paymentstr ? paymentstr : '{}');
        } else {
          this.payment = value;
        }

        if (!environment.production) {
          console.log('Payment selected: View ', this.payment);
        }
      });

      this.viewPaymentForm.setValue({
        amount: this.payment.amount,
        period_date: moment(this.payment.period_date).format('MMMM DD YYYY'),
        effective_date: moment(this.payment.effective_date).format('MMMM DD YYYY'),
        propertyName: localStorage.getItem('currentProperty') ? JSON.parse(localStorage.getItem('currentProperty') || '{}').name : '',
        paid_by: this.payment.paid_by,
        payment_method: this.payment.payment_method,
        description: this.payment.description,
        premiseId: this.payment.premise?.id,
        unitNumber: this.payment.premise?.unit_number,

      });
    }
  }

  get poa() { return this.viewPaymentForm.controls; }

  goBack() {
    this._location.back();
  }

}
